import React from "react";

interface BannerProps {
  banner: string;
  handleContinue: () => void;
}

const Banner: React.FC<BannerProps> = ({ banner, handleContinue }) => {
  return (
    <img
      src={banner}
      alt="Banner AeroMédica"
      className="banner-image"
      onClick={() => handleContinue()}
      tabIndex={0}
      aria-label="Abrir termo de adesão Aeromédica"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleContinue();
      }}
      style={{ cursor: "pointer" }}
    />
  );
};

export default Banner;